import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export interface TableColumn<T> {
  key: keyof T;
  label: string;
  align?: "left" | "right" | "center";
  format?: (value: T[keyof T]) => string;
}

interface InsightsTableProps<T> {
  title: string;
  columns: TableColumn<T>[];
  data: T[];
  isLoading?: boolean;
  getRowKey?: (row: T, index: number) => string | number;
}

export function InsightsTable<T>({
  title,
  columns,
  data,
  isLoading,
  getRowKey,
}: InsightsTableProps<T>) {
  if (isLoading) {
    return (
      <Paper elevation={1} sx={{ p: 2, textAlign: "center" }}>
        <CircularProgress size={24} />
      </Paper>
    );
  }

  return (
    <Paper elevation={1} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      {data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No data available
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                {columns.map((col) => (
                  <TableCell key={String(col.key)} align={col.align || "left"}>
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={getRowKey ? getRowKey(row, index) : index}>
                  {columns.map((col) => (
                    <TableCell
                      key={String(col.key)}
                      align={col.align || "left"}
                    >
                      {col.format
                        ? col.format(row[col.key])
                        : String(row[col.key] ?? "-")}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}
